//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import { getUrlparams, countDownTimeFunc, toCopy } from "@/utils/util.js";
import footerNav from "@/components/footerNav";
import homeTip from "@/components/homeTip";
import { Dialog, Toast } from "vant";
import Ios from "../../components/ios.vue";
import HomeTip from "../../components/homeTip.vue";

export default {
  name: "BuyPlan",
  components: {
    footerNav,
    homeTip,
    Ios,
    HomeTip
  },
  data() {
    return {
      searchValue: "",
      loading: false,
      finished: false,
      refreshing: false,
      purchaseList: [],
      idList: [],
      actions: [
        { name: "提交" },
        { name: "审核" },
        { name: "驳回" },
        { name: "下发" }
      ],
      toCopy,
      start: 0,
      size: 0
    };
  },
  provide() {
    return {
      submit: this.submit,
      audit: this.audit,
      rejected: this.rejected,
      Issued: this.Issued
    };
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    submit() {
      if (this.change(0)) {
        var params = { planOrderIdList: this.idList, planStatus: 1 };
        axiosApi.purchaseUpdate(params).then(response => {
          Toast.success("提交成功");
          this.onSearch();
        });
      } else {
        Toast.fail("状态异常");
      }
    },
    audit() {
      if (this.change(1) || this.change(2)) {
        var params = {
          planOrderIdList: this.idList,
          planStatus: 3,
          rejectRemark: ""
        };
        axiosApi.purchaseAudit(params).then(response => {
          Toast.success("审核成功");
          this.onSearch();
        });
      } else {
        Toast.fail("状态异常");
      }
    },
    rejected() {
      if (this.change(1) || this.change(2)) {
        var params = {
          planOrderIdList: this.idList,
          planStatus: 4,
          rejectRemark: "驳回"
        };
        axiosApi.purchaseAudit(params).then(response => {
          Toast.success("驳回成功");
          this.onSearch();
        });
      } else {
        Toast.fail("状态异常");
      }
    },
    Issued() {
      if (this.change(3)) {
        var planDetailList = [];
        this.purchaseList.forEach(item => {
          for (var i = 0; i < this.idList.length; i++) {
            if (this.idList[i] == item.planOrderId) {
              planDetailList[planDetailList.length] = item;
            }
          }
        });
        if (planDetailList.length != 0) {
          if (
            planDetailList.find(item => {
              return item.planStatus != 3;
            })
          ) {
            Toast.fail("状态异常");
          } else {
            if (
              planDetailList.find(item => {
                return planDetailList[0].secondDeptName != item.secondDeptName;
              })
            ) {
              Toast.fail("请选择同一采购部门的单据下发");
            } else {
              this.$router.push({
                name: "buyPlanIssued",
                query: {
                  planOrderId: this.idList
                }
              });
            }
          }
        } else {
          Toast.fail("请选择");
        }
      } else {
        Toast.fail("状态异常");
      }
    },
    submitGO(item) {
      this.idList = [];
      var params = { planOrderIdList: [item], planStatus: 1 };
      axiosApi.purchaseUpdate(params).then(response => {
        Toast.success("提交成功");
        this.onSearch();
      });
    },
    auditGO(item) {
      this.idList = [];
      var params = { planOrderIdList: [item], planStatus: 3, rejectRemark: "" };
      axiosApi.purchaseAudit(params).then(response => {
        Toast.success("审核成功");
        this.onSearch();
      });
    },
    rejectedGO(item) {
      this.idList = [];
      var params = {
        planOrderIdList: [item],
        planStatus: 4,
        rejectRemark: "驳回"
      };
      axiosApi.purchaseAudit(params).then(response => {
        Toast.success("驳回成功");
        this.onSearch();
      });
    },
    IssuedGO(item) {
      this.$router.push({
        name: "buyPlanIssued",
        query: {
          planOrderId: [item.planOrderId]
        }
      });
      this.onSearch();
    },
    change(type) {
      var isGo = true;
      for (let i = 0; i < this.idList.length; i++) {
        this.purchaseList.forEach(item => {
          if (this.idList[i] == item.planOrderId) {
            if (item.planStatus != type) {
              isGo = false;
            }
          }
        });
      }
      return isGo;
    },
    goPurchase(item) {
      if (item.planStatus != 0) {
        this.$router.push({
          name: "buyPlanView",
          query: {
            item: item,
            type: "view"
          }
        });
      } else {
        this.$router.push({
          name: "buyPlanView",
          query: {
            item: item,
            type: "edit"
          }
        });
      }
    },
    onSearch() {
      this.idList = [];
      var params = {
        searchValueList:
          this.searchValue == "" ? [] : this.searchValue.split(" "),
        start: this.start,
        size: this.size,
        orderRules: [{ orderKey: "t2.planOrderId", desc: true }],
        desc: true
      };
      axiosApi.queryPlanList(params).then(response => {
        if (
          response.content &&
          response.content.list &&
          response.content.list.length > 0
        ) {
          this.purchaseList.splice(0, this.purchaseList.length);
          this.purchaseList = response.content.list;
        }else{
          this.purchaseList = []
        }
        this.loading = false;
        this.refreshing = false;
        if (this.purchaseList.length == response.content.total) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.size = this.size + 10;
      var params = {
        searchValueList:
          this.searchValue == "" ? [] : this.searchValue.split(" "),
        start: this.start,
        size: this.size,
        orderRules: [{ orderKey: "t2.planOrderId", desc: true }],
        desc: true
      };
      axiosApi.queryPlanList(params).then(response => {
        if (
          response.content &&
          response.content.list &&
          response.content.list.length > 0
        ) {
          this.purchaseList.splice(0, this.purchaseList.length);
          this.purchaseList = response.content.list;
        }
        this.loading = false;
        this.refreshing = false;
        if (this.purchaseList.length == response.content.total) {
          this.finished = true;
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/buyPlan/index.vue